import { Injectable } from '@angular/core';

@Injectable()
export class MessageService {

    info(message: string, title?: string, options?: any): any {
        return solid.message.info(message, title);
    }

    success(message: string, title?: string, options?: any): any {
        return solid.message.success(message, title);
    }

    warn(message: string, title?: string, options?: any): any {
        return solid.message.warn(message, title);
    }

    error(message: string, title?: string, options?: any): any {
        return solid.message.error(message, title);
    }

    confirm(message: string, title?: string, callback?: (result: boolean) => void, options?: any): any {
        return solid.message.confirm(message, title, callback);
    }

}